import React, { useState, useContext } from "react";
import ActionsContext from "common/ActionsContext";
import Modal from "common/Modal.jsx";

const DPIProfileSettingsHelpModal = () => {
  const [open, setOpen] = useState(false);
  const actions = useContext(ActionsContext);
  actions.recv("open-settings-help", function () {
    setOpen(true);
  });
  const doClose = () => setOpen(false);
  if (open !== true) {
    return null;
  }

  return (
    <Modal
      title="DPI Profile settings"
      onClose={doClose}
      content={() => (
        <React.Fragment>
          <p>
            DPI Profile. Classify flows based on a list of L7 domains obtained
            by DPI.
          </p>
          <ul>
            <li>
              <b>NAME</b>: Profile name.
            </li>
            <li>
              <b>PRIORITY</b>: Evaluation priority. Lower numbers evaluated
              first. (Number from -9999 to 9999).
            </li>
            <li>
              <b>PATTERN</b>: DPI pattern to match. Wildchar * supported.
              Examples: "prefix*", "*suffix", "*substring*".
            </li>
            <li>
              <b>TYPE</b>: Type (HTTP, HTTPS, QUIC, ...).
            </li>
          </ul>
          <p>
            Click on the <i className="material-icons valign-icon">edit</i> icon
            to edit a profile.
          </p>
          <p>
            Click on the <i className="material-icons valign-icon">delete</i>{" "}
            icon to delete the profile.
          </p>
          <p>
            Press the <i className="material-icons valign-icon">more_vert</i>{" "}
            icon and then select the <b>Add Custom Signature...</b> option to
            add a new profile signature.
          </p>
          <p>
            Press the <i className="material-icons valign-icon">more_vert</i>{" "}
            icon and then select the <b>Add Signature File...</b> option to load
            signatures from a file.
          </p>
          <p>Each line of the file should follow this convention:
            <div className="text-code">
              PATTERN &#123; HTTP-host | HTTPS-SNI | QUIC-SNI &#125;
            </div>
            or
            <div className="text-code">
              &#123; P2P-FILESHARING | SPEEDTEST-OOKLA &#125;
            </div>
          </p>
          <p>
            Press the <i className="material-icons valign-icon">more_vert</i>{" "}
            icon and then select the <b>Add Predefined Signatures...</b> option
            to add one of the system predefined signatures.
          </p>
        </React.Fragment>
      )}
    />
  );
};

export default DPIProfileSettingsHelpModal;
